import { Injectable } from "@angular/core";
import { BaseService } from "../../shared/services/base.service";
import { AppComponent } from "../../app.component";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { Router } from "@angular/router";
import { ReleaseSettings } from "../models/releaseSettings.interface";

@Injectable()

export class ReleaseService extends BaseService {

  constructor(private appComponent: AppComponent, protected http: HttpClient, router: Router) {
    super(http, router);
  }

  getList(): Observable<ReleaseSettings[]> {
    return this.httpGet<ReleaseSettings[]>("/release");
  }

  getReleaseSetting(releaseSetting_ID: number): Observable<ReleaseSettings> {
    return this.httpGet<ReleaseSettings>("/release/" + releaseSetting_ID);
  }

  editReleaseSetting_ID(releaseSetting_ID: number): Observable<ReleaseSettings> {
    return this.httpGet<ReleaseSettings>("/release/" + releaseSetting_ID);
  }

  saveReleaseSetting(release: ReleaseSettings): Observable<number> {
    if (release.releaseSettings_ID == null)
      return this.httpPost<number>("/release/", release);
    else
      return this.httpPut<number>("/release/" + release.releaseSettings_ID, release);
  }

  getReleaseAttachment(releaseId: number): Observable<Blob> {
    return this.httpGetFile("/release/attachment/" + releaseId);
  }

}
